import React from "react";
import { FaLinkedinIn, FaGithub, FaWhatsapp } from "react-icons/fa";
import { logo } from "../../assets/index";

const Footer = () => {
  const quickLinks = [
    { label: "About", href: "#home" },
    { label: "Skills", href: "#features" },
    { label: "Projects", href: "#projects" },
    { label: "Resume", href: "#resume" },
    { label: "Contact", href: "#contact" },
  ];

  const resourcesLinks = [
    { label: "Playwright Docs", href: "https://playwright.dev/docs/intro" },
    { label: "Cypress Docs", href: "https://docs.cypress.io" },
    { label: "Serenity BDD Docs", href: "https://serenity-bdd.github.io/docs/" },
    { label: "Appium Docs", href: "https://appium.io/docs/en/latest/" },
    { label: "k6 Docs", href: "https://k6.io/docs/" },
  ];

  const developersLinks = [
    { label: "GitHub Actions", href: "https://docs.github.com/en/actions" },
    { label: "Azure DevOps Pipelines", href: "https://learn.microsoft.com/en-us/azure/devops/pipelines/" },
    { label: "Cucumber (BDD)", href: "https://cucumber.io/docs/" },
    { label: "REST API Testing", href: "https://restfulapi.net/" },
    { label: "My GitHub", href: "https://github.com/cesaragudeloh" },
  ];

  const LinkItem = ({ label, href, external = false }) => (
    <li>
      <a
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
        className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer"
      >
        {label}
        <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
      </a>
    </li>
  );

  return (
    <div className="w-full py-20 h-auto border-b-[1px] border-b-black grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-4 gap-8">
      {/* Social */}
      <div className="w-full h-full flex flex-col gap-8">
        <img className="w-32" src={logo} alt="logo" />
        <div className="flex gap-4">
          <a
            className="bannerIcon"
            href="https://www.linkedin.com/in/cesar-agudelo/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
          <a
            className="bannerIcon"
            href="https://github.com/cesaragudeloh"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            className="bannerIcon"
            href="https://wa.me/573127555467"
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>

      {/* Quick Links (keep only if your sections exist) */}
      {quickLinks?.length > 0 && (
        <div className="w-full h-full">
          <h3 className="text-xl uppercase text-designColor tracking-wider">
            Quick Links
          </h3>
          <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 overflow-hidden">
            {quickLinks.map((l) => (
              <LinkItem key={l.label} label={l.label} href={l.href} />
            ))}
          </ul>
        </div>
      )}

      {/* Resources */}
      {resourcesLinks?.length > 0 && (
        <div className="w-full h-full">
          <h3 className="text-xl uppercase text-designColor tracking-wider">
            RESOURCES
          </h3>
          <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 overflow-hidden">
            {resourcesLinks.map((l) => (
              <LinkItem
                key={l.label}
                label={l.label}
                href={l.href}
                external
              />
            ))}
          </ul>
        </div>
      )}

      {/* Developers */}
      {developersLinks?.length > 0 && (
        <div className="w-full h-full">
          <h3 className="text-xl uppercase text-designColor tracking-wider">
            DEVELOPERS
          </h3>
          <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden py-6">
            {developersLinks.map((l) => (
              <LinkItem
                key={l.label}
                label={l.label}
                href={l.href}
                external
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Footer;